/* Promo countdown (sections/kk-promo.liquid), ported from Charmlry's promo-countdown.
   Site: the first bar of the header group, one line when it fits, two otherwise (the
   kicker never goes); the announcement bar is hidden while it shows. Kit flow:
   window.KikiriePromo.kicker() puts the kicker on the gifts-step coupon (kk-flow.js) and
   window.KikiriePromo.pieces(el) drops the paper pieces under it. blockHtml() gives the
   whole bar content as a block (not used by the flow since Paolo dropped it from the review). */
(function () {
  var roots = document.querySelectorAll('[data-pcd]');
  if (!roots.length) return;

  var offset = 0;
  try {
    var at = new URLSearchParams(location.search).get('pcd_at');
    if (at) { var t = Date.parse(at); if (!isNaN(t)) offset = t - Date.now(); }
  } catch (err) { /* ignore */ }
  function now() { return Date.now() + offset; }
  // "YYYY-MM-DD HH:MM" (time optional) on the browser's clock; 0 when unreadable.
  function local(str) {
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/.exec(str || '');
    return m ? new Date(+m[1], m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0)).getTime() : 0;
  }
  function shiftDay(ts, n) { var x = new Date(ts); x.setDate(x.getDate() + n); return x.getTime(); }
  function p2(n) { return (n < 10 ? '0' : '') + n; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Hours left: "5h 07m". Minutes left: "12m 05s". Days (end mode): "3d 14h".
  function fmt(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    if (d > 0) return d + 'd ' + h + 'h';
    if (h > 0) return h + 'h ' + p2(m) + 'm';
    if (m > 0) return m + 'm ' + p2(x) + 's';
    return x + 's';
  }

  var MOON_PATH = 'M20.6 14.2A8.6 8.6 0 0 1 9.8 3.4a.6.6 0 0 0-.8-.7 9.6 9.6 0 1 0 12.3 12.3.6.6 0 0 0-.7-.8z';
  var MOON = '<svg class="pcd__moon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="' + MOON_PATH + '"/></svg>';
  // Paper pieces cut for the occasion: bat, moon, star.
  var SHAPES = {
    bat: 'M12 8.6c-.7 0-1.2.5-1.4 1.2l-.5-1.1-.3 1.6C8.6 8.9 6.6 8.5 4.6 9.3c.9.5 1.4 1.4 1.4 2.4-1.7-.5-3.6 0-5 1.2 2.3-.1 4.1.7 5.2 2.2 1-1 2.4-1.4 3.7-1.1L12 16.2l2.1-2.2c1.3-.3 2.7.1 3.7 1.1 1.1-1.5 2.9-2.3 5.2-2.2-1.4-1.2-3.3-1.7-5-1.2 0-1 .5-1.9 1.4-2.4-2-.8-4-.4-5.4.8l-.3-1.6-.5 1.1c-.2-.7-.7-1.2-1.4-1.2z',
    moon: MOON_PATH,
    star: 'M12 2.5l2 7.5 7.5 2-7.5 2-2 7.5-2-7.5-7.5-2 7.5-2z'
  };
  // left %, shape, paper or gold, size px, delay s, turn deg
  var PIECES = [[6, 'star', 0, 11, .1, 140], [15, 'bat', 0, 18, .35, -25], [27, 'moon', 1, 13, 0, 60], [39, 'star', 1, 9, .5, -120], [50, 'bat', 0, 16, .15, 30], [61, 'star', 0, 10, .4, 160], [72, 'moon', 0, 12, .25, -70], [83, 'bat', 1, 15, .05, -20], [93, 'star', 0, 9, .3, 110]];

  // Paper pieces fall under `anchor` (inside `host`), twice, then gone. `lift` goes above
  // its neighbours meanwhile (the site bar's section sits under the sticky header).
  function pieces(host, lift, anchor) {
    var box = document.createElement('div');
    box.className = 'pcd__pieces';
    box.setAttribute('aria-hidden', 'true');
    if (anchor && anchor !== host) {
      var a = anchor.getBoundingClientRect(), h = host.getBoundingClientRect();
      box.style.cssText = 'top:' + (a.bottom - h.top) + 'px;left:' + (a.left - h.left) + 'px;width:' + a.width + 'px;z-index:10';
    }
    PIECES.forEach(function (p) {
      var el = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      el.setAttribute('class', 'pcd__piece' + (p[2] ? ' pcd__piece--gold' : ''));
      el.setAttribute('viewBox', '0 0 24 24');
      el.setAttribute('style', 'left:' + p[0] + '%;width:' + p[3] + 'px;height:' + p[3] + 'px;animation-delay:' + p[4] + 's;--pcd-turn:' + p[5] + 'deg');
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', SHAPES[p[1]]);
      path.setAttribute('fill', 'currentColor');
      el.appendChild(path);
      box.appendChild(el);
    });
    host.appendChild(box);
    if (lift) lift.style.zIndex = '30';
    setTimeout(function () { box.remove(); if (lift) lift.style.zIndex = ''; }, 6000); // 2 × 2.6s + last delay
  }

  var blocks = []; // one per bar that also shows in the kit flow

  Array.prototype.forEach.call(roots, function (root) {
    if (root.dataset.pcdInit) return;
    root.dataset.pcdInit = '1';
    var d = root.dataset;
    var S, E, ED, PD, SP, SPE;
    if (d.clock === 'visitor') {
      // Same dates on the visitor's own clock: midnight is their midnight.
      S = local(d.startRaw); E = local(d.endRaw);
      if (/23:59$/.test(d.endRaw || '')) E += 60000;
      ED = local((d.endRaw || '').slice(0, 10)); PD = shiftDay(ED, -1);
      SP = local(d.specialRaw); SPE = SP ? shiftDay(SP, 1) : 0;
    } else {
      S = +d.start * 1000; E = +d.end * 1000; ED = +d.endDay * 1000; PD = +d.prevDay * 1000;
      SP = +d.special * 1000; SPE = +d.specialEnd * 1000;
    }
    var editor = d.editor === 'true';
    var daily = d.mode === 'midnight';
    var arrivalDays = +d.arrivalDays || 12;
    var business = d.arrivalUnit !== 'calendar';
    var bar = root.querySelector('.pcd__bar');
    var offer = (root.querySelector('.pcd__offer') || {}).textContent || '';

    // Daily mode: the deadline is tonight's midnight and the stake is the arrival date,
    // which really moves after it (12 business days, like the shipping policy and the
    // order emails: weekends skipped). "Shop" clock = New York midnight for everyone.
    function nyParts(t) {
      var p = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hourCycle: 'h23', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
        .formatToParts(new Date(t)).forEach(function (x) { p[x.type] = +x.value; });
      return p;
    }
    function midnight(t) {
      if (d.clock === 'visitor') { var x = new Date(t); x.setHours(24, 0, 0, 0); return x.getTime(); }
      var p = nyParts(t);
      return t + (86400 - (p.hour * 3600 + p.minute * 60 + p.second)) * 1000 - (t % 1000);
    }
    function arrival(t) {
      var x;
      if (d.clock === 'visitor') { x = new Date(t); } else { var p = nyParts(t); x = new Date(p.year, p.month - 1, p.day); }
      if (!business) { x.setDate(x.getDate() + arrivalDays); } else {
        for (var left = arrivalDays; left > 0;) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) left--; }
      }
      return x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }

    var state = { visible: false, phase: '', kicker: '', len: -1, level: 0, arr: '', hot: false, left: 0 };
    // [two lines, label size, tight]. The kicker never goes: one line first, then
    // kicker + offer above and label + timer below. Tight = no moon, closer letters.
    var LEVELS = [[0, 'long', 0], [0, 'short', 0], [0, 'short', 1], [1, 'long', 0], [1, 'short', 0], [1, 'long', 1], [1, 'short', 1]];

    function texts(phase, size, arr) {
      if (daily) return [size === 'long' ? d.lOrder : d.lOrderShort, (size === 'long' ? d.aLong : d.aShort).replace('[arrival]', arr)];
      if (phase === 'tonight') return [size === 'long' ? d.lTonight : d.lTonightShort, ''];
      if (phase === 'tomorrow') return [size === 'long' ? d.lTomorrow : d.lTomorrowShort, ''];
      return [size === 'long' ? d.lEnds : '', ''];
    }
    function apply(lv) {
      var L = LEVELS[lv], tx = texts(state.phase, L[1], state.arr);
      bar.classList.toggle('pcd__bar--two', !!L[0]);
      bar.classList.toggle('pcd__bar--tight', !!L[2]);
      var el = bar.querySelector('.pcd__lbl');
      el.textContent = tx[0]; el.hidden = !tx[0];
      var af = bar.querySelector('.pcd__aft');
      af.textContent = tx[1]; af.hidden = !tx[1];
      bar.querySelector('.pcd__sep2').hidden = !tx[1];
      bar.querySelector('.pcd__t').textContent = fmt(state.left);
    }
    function fits(two) {
      if (!two) return bar.scrollWidth <= bar.clientWidth + 1;
      var room = bar.clientWidth - 24 + 1; // 12px side padding
      return bar.querySelector('.pcd__l1').offsetWidth <= room && bar.querySelector('.pcd__l2').offsetWidth <= room;
    }
    // Longest layout that fits (one line, else two).
    function fit() {
      for (var i = 0; i < LEVELS.length; i++) {
        apply(i);
        if (fits(LEVELS[i][0])) return i;
      }
      return LEVELS.length - 1;
    }

    // In the kit flow there is room: always the long texts, two lines.
    function blockParts() {
      var tx = texts(state.phase, 'long', state.arr);
      return {
        head: esc(state.kicker) + ' <span class="pcd-in__sep">·</span> ' + esc(offer),
        line: (tx[0] ? esc(tx[0]) + ' ' : '') + '<b class="pcd-in__t">' + esc(fmt(state.left)) + '</b>' + (tx[1] ? ' <span class="pcd-in__sep">·</span> ' + esc(tx[1]) : '')
      };
    }
    function blockHtml() {
      if (!state.visible) return '';
      var b = blockParts();
      return '<div class="pcd-in' + (state.hot ? ' pcd--tonight' : '') + '" data-pcd-in>' +
        '<span class="pcd-in__icon">' + MOON + '</span>' +
        '<span class="pcd-in__text"><span class="pcd-in__head">' + b.head + '</span><span class="pcd-in__line">' + b.line + '</span></span></div>';
    }
    function paintBlocks() {
      var b = blockParts();
      Array.prototype.forEach.call(document.querySelectorAll('[data-pcd-in]'), function (el) {
        var h = el.querySelector('.pcd-in__head'), l = el.querySelector('.pcd-in__line');
        if (h && h.innerHTML !== b.head) h.innerHTML = b.head;
        if (l && l.innerHTML !== b.line) l.innerHTML = b.line;
        el.classList.toggle('pcd--tonight', state.hot);
      });
    }
    if (d.inFlow === 'true') blocks.push({ html: blockHtml, pieces: d.pieces === 'true', kicker: function () { return state.visible ? state.kicker : ''; } });

    function tick() {
      var t = now();
      state.visible = editor || ((!S || t >= S) && t < E);
      root.hidden = !state.visible;
      if (d.hideAnnouncement === 'true') document.documentElement.classList.toggle('pcd-on', state.visible && !editor);
      if (!state.visible) return false;
      state.left = daily ? midnight(t) - t : E - t;
      var phase = daily ? 'daily' : t >= ED ? 'tonight' : t >= PD ? 'tomorrow' : 'ends';
      var hot = daily ? state.left < 3600000 : phase === 'tonight';
      var kicker = SP && t >= SP && t < SPE ? d.specialKicker : d.kicker;
      var arr = daily ? arrival(t) : '';
      var len = fmt(state.left).length;
      if (phase !== state.phase || kicker !== state.kicker || len !== state.len || arr !== state.arr || hot !== state.hot) {
        bar.querySelector('.pcd__kick').textContent = kicker;
        root.classList.toggle('pcd--tonight', hot);
        state.phase = phase; state.kicker = kicker; state.len = len; state.arr = arr; state.hot = hot;
        state.level = fit();
      }
      apply(state.level);
      if (d.inFlow === 'true') paintBlocks();
      return true;
    }

    if (tick() && d.pieces === 'true' && !reduced && !editor) {
      var key = 'kikirie.pcd.pieces.' + d.end;
      var seen = false;
      try { seen = !!sessionStorage.getItem(key); sessionStorage.setItem(key, '1'); } catch (err) { /* ignore */ }
      // Horizon's header-group sections are static: lift the bar itself above the sticky header (z 18).
      if (!seen) pieces(root, root);
    }
    var timer = setInterval(function () { tick(); if (!editor && now() >= E) clearInterval(timer); }, 1000);
    var rz;
    function refit() { state.phase = ''; tick(); }
    window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(refit, 150); });
    // The first fit can run before the stylesheet and the fonts are in: fit again then.
    window.addEventListener('load', refit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refit);
  });

  // Read by kk-flow.js: kicker() is '' when no promo is running; pieces(el) drops the paper
  // pieces under an element (the flow calls it once per open, at the gifts-step coupon).
  window.KikiriePromo = {
    moon: MOON,
    // the kicker on screen now ("Halloween", "Trick or treat"), '' when no promo is running
    kicker: function () {
      for (var i = 0; i < blocks.length; i++) { var k = blocks[i].kicker(); if (k) return k; }
      return '';
    },
    blockHtml: function () {
      for (var i = 0; i < blocks.length; i++) { var h = blocks[i].html(); if (h) return h; }
      return '';
    },
    pieces: function (el) {
      if (!el || reduced) return;
      for (var i = 0; i < blocks.length; i++) {
        if (blocks[i].pieces) { pieces(el.closest('dialog') || el.parentElement, null, el); return; }
      }
    }
  };
})();
